import React, { PureComponent as Component } from "react";
import ButtonTheme from "css/themes/Buttons.css";
import SocialTheme from "css/themes/SocialGrowth.css";
import DialogTheme from "css/themes/dialogs/formModal.css";
import { memoize } from "lodash";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Button } from "react-toolbox/lib/button";
import { Dialog } from "react-toolbox/lib/dialog";
import * as metrics from "util/metrics";
import { H1, H3, H4, Small } from "visual-components/util/texts";

class SocialActionsUpsellModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeUpsellModal: PropTypes.func.isRequired,
    openPurchaseModal: PropTypes.func,
    history: PropTypes.object,
  };

  static defaultProps = {
    isOpen: false,
  };

  track = memoize((button) => () => {
    metrics.create("socialActionsModalClicked", {
      meta: {
        action: button,
      },
    });
  });

  closeModal = () => {
    const { closeUpsellModal } = this.props;

    metrics.create("SocialActionsModalClosed");
    closeUpsellModal();
  };

  handlePurchaseClick = () => {
    const { closeUpsellModal, history } = this.props;
    this.track("purchase")();
    closeUpsellModal();
    history.push("/partnerships/purchase-social-actions");
  };

  handleUpgradeClick = () => {
    const { closeUpsellModal, history } = this.props;
    this.track("upgradePlan")();
    closeUpsellModal();
    history.push("/upgrade-plan");
  };

  render() {
    const { isOpen } = this.props;

    return (
      <Dialog
        title="Looking to drive more sales and growth?"
        type="large"
        active={isOpen}
        onEscKeyDown={this.closeModal}
        onOverlayClick={this.closeModal}
        theme={DialogTheme}
      >
        <img
          onClick={this.closeModal}
          className={DialogTheme.closeImage}
          src="/images/icons/close.svg"
        />
        <div className={SocialTheme.titleContainer}>
          <H4 multiline ink>
            Upgrade to Premium plan
          </H4>
          <ul>
            <li>Unlimited social actions (unlock massive brand awareness and social growth)</li>
            <li>
              Post Entry Custom Call to Action (drive thousands of visitors to your website/offers)
            </li>
          </ul>
        </div>
        <div className={SocialTheme.cardsContainer}>
          <div className={SocialTheme.card}>
            <img src="/images/social-action-assets/planet-icon.svg" />
            <div className={SocialTheme.copyContainer}>
              <H4>
                <i>Upgrade to Premium plan</i>
              </H4>
              <Small>Unlimited social actions & Post Entry Custom CTA</Small>
              <div className={SocialTheme.priceContainer}>
                <div className={SocialTheme.dollarSign}>
                  <H3>$</H3>
                </div>
                <div className={SocialTheme.dollarValue}>
                  <H1>499</H1>
                </div>
                <div className={SocialTheme.trailingText}>
                  <H4>/ mo.</H4>
                </div>
              </div>
              <Button
                onClick={this.handleUpgradeClick}
                theme={ButtonTheme}
                className={ButtonTheme.whiteButtonAzureText}
                label="Upgrade Now"
              />
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default withRouter(SocialActionsUpsellModal);
